<template>
  <cc-container class="detail">
    <cc-header title="关联单号详情">
    </cc-header>
    <cc-main>
      <section class="collapse">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item name="1">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-order"></i>
              <p class="collapse-title">
                关联单号信息
              </p>
            </div>
            <p class="collapse-item">
              订单单号：{{detail.order.order_number}}
            </p>
            <p class="collapse-item">
              订单状态：{{detail.order.order_state_name}}
            </p>
            <p class="collapse-item">
              支付方式：{{detail.order.payment_method_name}}
            </p>
            <p class="collapse-item">
              下单时间：{{detail.order.post_date}}
            </p>
          </van-collapse-item>

          <van-collapse-item title="配送信息" name="2">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-position"></i>
              <p class="collapse-title">
                配送信息
              </p>
            </div>
            <p class="collapse-item">
              联系人：{{detail.order.contacter}}
            </p>
            <p class="collapse-item">
              联系电话：{{detail.order.mobile}}
            </p>
            <p class="collapse-item">
              收货单位：{{detail.order.customer_name}}
            </p>
            <p class="collapse-item">
              收货地址：{{detail.order.address}}
            </p>
          </van-collapse-item>
        </van-collapse>
      </section>

      <product-list :list="detail.goods">
        <!-- <product-item v-for="item in detail.goods" :key="item.id" :item="item" :checkbox="false"></product-item> -->
      </product-list>

      <section class="summary-box">
        <div>
          <p class="pl10">
            本单总合计：<span class="price">￥{{detail.order_amount}}</span>
          </p>
        </div>
        <p class="pl10">
          整单优惠：<span class="price">￥{{detail.order.coupon_price}}</span>
        </p>
      </section>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Collapse, CollapseItem, Checkbox, Lazyload, Button } from 'vant'
import { types } from '../../../../store/modules/order'
import ProductList from '../components/product-list'
Vue.use(Collapse).use(CollapseItem).use(Checkbox).use(Lazyload).use(Button)
export default {
  name: 'order-detail',
  components: {
    ProductList
  },
  data () {
    return {
      activeNames: '1',
      detail: {
        order: {},
        goods: {}
      }
    }
  },
  computed: {
    ...mapGetters(['getOrderDetail'])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions([types.GET_ORDER_DETAIL]),
    async loadData () {
      await this.GET_ORDER_DETAIL({
        order_number: this.$route.params.id
      })
      this.$tips(this.getOrderDetail, res => {
        res.goods = this.normalizeGoods(res.goods)
        this.detail = res
      })
    },
    /**
     * 格式化商品列表数据
     * @param {Array} goods 所有商品
     */
    normalizeGoods: function (goods) {
      var arr = []
      var field = ['exchange', 'gifts', 'lownow', 'putongspecial', 'promotion']
      field.map(key => {
        if (goods[key]) {
          goods[key].map(good => {
            if (key !== 'promotion') {
              arr.push(good)
            } else {
              var promotion = []
              good.map(item => {
                // 用于标识该商品是促销商品
                item._isPromotion = true
                promotion.push(item)
              })
              arr.push(promotion)
            }
          })
        }
      })
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.detail {
  .collapse {
    box-shadow: $box-shadow-base;
    .collapse-title-box {
      @include flex(row);
      align-items: center;
      .collapse-title {
        padding-left: 10px;
      }
    }
    .collapse-item {
      font-size: 12px;
      color: #333;
      margin-left: 40px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 1px solid #EEEEEE;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .checkbox {
    padding-left: 5px;
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin: 8px 0;
    justify-content: space-between;
    padding-right: 10px;
  }
}
.cc-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-order {
  background: url('~assets/img/sprites/order/order.png');
  background-size: 20px 20px;
}
.icon-position {
  background: url('~assets/img/sprites/order/position.png');
  background-size: 20px 20px;
}
</style>
<style lang="scss">
.detail {
  .van-collapse-item__content {
    padding: 0
  }
}
</style>
